export default {
  data() {
    return {
      operators: {
        '>': (a, b) => a > b,
        '>=': (a, b) => a >= b,
        '<': (a, b) => a < b,
        '<=': (a, b) => a <= b,
        '===': (a, b) => a === b,
        '!==': (a, b) => a !== b,
      },
    }
  },
  methods: {
    compareValues(a, b, operator) {
      return this.operators[operator](a, b)
    },
  },
}
